<template>
  <div class="tile is-child box has-sticky-tile"
    style="margin-bottom: 1rem !important;">
    <div class="columns">
      <div class="column is-narrow is-flex is-align-items-center is-justify-content-center">
        <strong class="is-size-5 has-text-primary batch-title">Batch {{ value.batchNo }}</strong>
      </div>
      <div class="column is-narrow is-flex is-align-items-center is-justify-content-center">
        <div class="is-flex  is-flex-direction-column">
          <span class="">Batch Status</span>
          <div class="select is-fullwidth is-small">
            <select v-model="value.batchStatus"
              :disabled="!isCanEdit">
              <option v-for="(status, propertyName) in ormBatchStatusType"
                :value="status"
                :key="status">
                {{ propertyName | formatOrmBatchStatus }}
              </option>
            </select>
          </div>
        </div>
        <!-- <span class="is-size-4 has-text-weight-bold is-size-6 pr-3">Status</span><br>
        <div class="select is-fullwidth">
          <select v-model="value.batchStatus">
            <option v-for="(status, propertyName) in ormBatchStatusType"
              :value="status"
              :key="status">
              {{ propertyName | formatOrmBatchStatus }}
            </option>
          </select>
        </div> -->
      </div>
      <div class="column">
        <div class="is-flex is-flex-direction-row is-justify-content-space-between"
          style="width: 100%;">
          <div class="is-flex  is-flex-direction-column is-align-items-center">
            <span class="header-text-divider">Batch Total Jobs</span>
            <span class="is-size-4 is-size-4 has-text-weight-bold">{{ quotes.length }}</span>
          </div>
          <div class="is-flex  is-flex-direction-column is-align-items-center">
            <span class="header-text-divider">Total Value Range</span>
            <span class="is-size-4 is-size-4 has-text-weight-bold">{{ value.perQuoteTotalMin ?? 0 | formatCurrency($userInfo.locale, false, 0) }} - {{ value.perQuoteTotalMax | formatCurrency($userInfo.locale, false, 0) }}</span>
          </div>
          <div class="is-flex  is-flex-direction-column is-align-items-center">
            <span class="header-text-divider">Actual ARC</span>
            <span class="is-size-4 is-size-4 has-text-weight-bold">{{ actualARC | formatCurrency($userInfo.locale) }}</span>
          </div>
          <div class="is-flex  is-flex-direction-column is-align-items-center">
            <span class="header-text-divider">Target ARC</span>
            <span class="is-size-4 is-size-4 has-text-weight-bold">{{ value.agreedArc | formatCurrency($userInfo.locale) }}</span>
          </div>
          <div class="is-flex  is-flex-direction-column is-align-items-center">
            <span class="header-text-divider">ALR Threshold</span>
            <span class="is-size-4 is-size-4 has-text-weight-bold">{{ value.alrLowerThreshold | formatCurrency($userInfo.locale) }} - {{ value.alrUpperThreshold | formatCurrency($userInfo.locale) }}</span>
          </div>
          <div class="is-flex  is-flex-direction-column is-align-items-center">
            <span class="header-text-divider">
              Actual Labour Rate
            </span>
            <span class="is-size-4 is-size-4 has-text-weight-bold"
              :class="{ 'has-text-danger' : alr < alrLowerThreshold || alr > alrUpperThreshold }">
              {{ alr | formatCurrency($userInfo.locale) }}
              <span v-show="alr < alrLowerThreshold || alr > alrUpperThreshold"
                class="icon has-text-danger tooltip is-tooltip-danger"
                :data-tooltip="alr < alrLowerThreshold ? 'ALR is below threshold' : 'ALR is above threshold'">
                <i class="mdi mdi-alert" />
              </span>
            </span>
          </div>
          <div class="is-flex  is-flex-direction-column is-align-items-center">
            <span class="header-text-divider">Estimated Adjusted Labour Rate</span>
            <span class="is-size-4 is-size-4 has-text-weight-bold"
              :class="{ 'has-text-danger' : adjustedAlr < alrLowerThreshold || adjustedAlr > alrUpperThreshold, 'has-text-success': adjustedAlr >= alrLowerThreshold && adjustedAlr <= alrUpperThreshold }">
              {{ adjustedAlr | formatCurrency($userInfo.locale) }}
              <span v-show="adjustedAlr < alrLowerThreshold || adjustedAlr > alrUpperThreshold"
                class="icon has-text-danger tooltip is-tooltip-danger"
                :data-tooltip="adjustedAlr > alr ? 'Increase the labour rate' : 'Decrease the labour rate'">
                <i class="mdi mdi-alert" />
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { NumberFiltersMixin } from '@/components/mixins/filters'
import { InsurerService } from '@/services'
import { OrmBatchStatusType } from '@/enums'
import OrmBatchingMixin from '../OrmBatchingMixin'

export default {
  name: 'OrmBatchStatistics2',
  components: {},
  filters: {},
  mixins: [NumberFiltersMixin, OrmBatchingMixin],
  props: {
    value: null,
    quotes: null,
    count: 0,
    alr: 0,
    alrLowerThreshold: 0,
    alrUpperThreshold: 0,
    // averageLabourUnits: 0,
    // averageLabourValues: 0,
    // averageNonLabourValues: 0,
    averageTotalExGst: 0,
    adjustedTotal: 0,
    adjustedAlr: 0,
    isCanEdit: false
  },
  data: () => {
    return {
      insurer: null
    }
  },
  computed: {
    actualARC() {
      if (this.quotes.length == 0) return 0.0
      // const total = this.quotes.reduce((sum, item) => sum + item.totalNotInvoiced, 0)
      const total = this.quotes.reduce((sum, item) => sum + item.totalExGST, 0)
      return total / this.quotes.length
    },
    ormBatchStatusType() {
      return OrmBatchStatusType
    }
  },
  watch: {},
  async created() {
    if (this.value && this.value.insurerId) {
      this.insurer = await InsurerService.getEntity(this.value.insurerId)
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.splitter {
  display: flex;
  align-items: center;
  justify-content: center;
  color: lightgray;
}
.header-text-divider {
  border-bottom: 1px solid lightgray;
}
.has-sticky-tile {
  position: sticky;
  top: 3.25rem;
  z-index: 31;
}
.batch-title {
  font-size: 1.5rem !important;
  color: #1a5276 !important;
  padding-right: 40px;
}
</style>